import { ValidationError } from '../ValidationError'
import { ValidatorAbstract } from '../ValidatorAbstract'
import { VALIDATION_MESSAGES } from '../messages'

class LitographedBoxValidator extends ValidatorAbstract {
  validate () {
    const errors = []
    const { size, amount } = this.formModel

    if (!size.length || !size.height || !size.depth) {
      errors.push(new ValidationError(1, VALIDATION_MESSAGES.MEASURE_REQUIRED))
    }
    if (!amount) {
      errors.push(new ValidationError(4, VALIDATION_MESSAGES.QUANTITY_REQUIRED))
    }

    this.errors = errors
  }
}

export default LitographedBoxValidator
